"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticOrderAddressType = exports.AutomaticOrderInterval = exports.OrderCancelType = exports.OrderCondition = exports.OrderStatusCode = exports.OrderItemStatusCode = exports.OrderDeliverySchedule = exports.OrderRequestPickPostPrefix = exports.DeliveryType = exports.DeliveryAddressType = exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["ASC"] = "created_asc";
    OrderType["DESC"] = "created_desc";
})(OrderType || (exports.OrderType = OrderType = {}));
var DeliveryAddressType;
(function (DeliveryAddressType) {
    DeliveryAddressType[DeliveryAddressType["Address"] = 0] = "Address";
    DeliveryAddressType[DeliveryAddressType["Doctor"] = 1] = "Doctor";
    DeliveryAddressType[DeliveryAddressType["Pharmacy"] = 2] = "Pharmacy";
    DeliveryAddressType[DeliveryAddressType["PickPost"] = 3] = "PickPost";
})(DeliveryAddressType || (exports.DeliveryAddressType = DeliveryAddressType = {}));
var DeliveryType;
(function (DeliveryType) {
    DeliveryType[DeliveryType["Express"] = 1] = "Express";
    DeliveryType[DeliveryType["Standard"] = 2] = "Standard";
})(DeliveryType || (exports.DeliveryType = DeliveryType = {}));
var OrderRequestPickPostPrefix;
(function (OrderRequestPickPostPrefix) {
    OrderRequestPickPostPrefix["PickPost"] = "PickPost";
    OrderRequestPickPostPrefix["MyPost24"] = "MyPost24";
})(OrderRequestPickPostPrefix || (exports.OrderRequestPickPostPrefix = OrderRequestPickPostPrefix = {}));
var OrderDeliverySchedule;
(function (OrderDeliverySchedule) {
    OrderDeliverySchedule["BusinessDayFrom7To17"] = "BusinessDayFrom7To17";
    OrderDeliverySchedule["BusinessDayFrom9To12"] = "BusinessDayFrom9To12";
    OrderDeliverySchedule["BusinessDayFrom11To14"] = "BusinessDayFrom11To14";
    OrderDeliverySchedule["BusinessDayFrom12To17"] = "BusinessDayFrom12To17";
    OrderDeliverySchedule["SaturdayFrom9To12"] = "SaturdayFrom9To12";
})(OrderDeliverySchedule || (exports.OrderDeliverySchedule = OrderDeliverySchedule = {}));
var OrderItemStatusCode;
(function (OrderItemStatusCode) {
    OrderItemStatusCode["Created"] = "created";
    OrderItemStatusCode["NotAvailable"] = "notAvailable";
    OrderItemStatusCode["ShippingPrepared"] = "shippingPrepared";
    OrderItemStatusCode["OrderedSupplier"] = "orderedSupplier";
    OrderItemStatusCode["Closed"] = "closed";
    OrderItemStatusCode["Sent"] = "sent";
    OrderItemStatusCode["ReceivedByCustomer"] = "receivedByCustomer";
})(OrderItemStatusCode || (exports.OrderItemStatusCode = OrderItemStatusCode = {}));
var OrderStatusCode;
(function (OrderStatusCode) {
    OrderStatusCode["Unknown"] = "unknown";
    OrderStatusCode["Created"] = "created";
    OrderStatusCode["ShippingPrepared"] = "shippingPrepared";
    OrderStatusCode["Shipped"] = "shipped";
    OrderStatusCode["ProcessedByCustomerService"] = "processedByCustomerService";
    OrderStatusCode["Planned"] = "planned";
    OrderStatusCode["Canceled"] = "canceled";
})(OrderStatusCode || (exports.OrderStatusCode = OrderStatusCode = {}));
var OrderCondition;
(function (OrderCondition) {
    OrderCondition["Open"] = "offen";
    OrderCondition["Closed"] = "abgeschlossen";
    OrderCondition["Scheduled"] = "geplant";
})(OrderCondition || (exports.OrderCondition = OrderCondition = {}));
var OrderCancelType;
(function (OrderCancelType) {
    OrderCancelType["AllFollowing"] = "allFollowing";
    OrderCancelType["Single"] = "single";
})(OrderCancelType || (exports.OrderCancelType = OrderCancelType = {}));
var AutomaticOrderInterval;
(function (AutomaticOrderInterval) {
    AutomaticOrderInterval["every3Month"] = "P3M";
})(AutomaticOrderInterval || (exports.AutomaticOrderInterval = AutomaticOrderInterval = {}));
var AutomaticOrderAddressType;
(function (AutomaticOrderAddressType) {
    AutomaticOrderAddressType[AutomaticOrderAddressType["domicil"] = 0] = "domicil";
    AutomaticOrderAddressType[AutomaticOrderAddressType["delivery"] = 1] = "delivery";
})(AutomaticOrderAddressType || (exports.AutomaticOrderAddressType = AutomaticOrderAddressType = {}));
//# sourceMappingURL=order.js.map